import { Space, Tooltip } from "antd";
import UserIcon from "../../../assets/icons/UserIcon";
import UserImg from "../../../assets/images/avatar.svg";
import InfoTitle from "../../common/InfoTitle";

interface EmployeeInfoProps {
  name?: string;
  designation?: string;
  department?: string;
  email?: string | null;
  joinedDate?: string;
  image?: string;
  employeeId?: string;
}

export default function EmployeeInfo({
  name,
  employeeId,
  email,
  department,
  designation,
  joinedDate,
  image,
}: EmployeeInfoProps) {
  return (
    <div className="md:col-span-3">
      <div className="bg-white rounded-md border border-extra-light p-6">
        <InfoTitle className="mb-6" icon={<UserIcon />}>
          Employee Info
        </InfoTitle>

        <Space align="start" className="w-full" size={16}>
          <div className="w-24 h-24">
            <img
              className="w-full h-full rounded-full"
              src={image || UserImg}
              alt=""
            />
          </div>
          <div className="flex flex-col gap-0.5">
            <h3 className="text-body text-lg font-semibold leading-normal">
              {name || "Name: N/A"}
            </h3>
            <p className="text-extra-gray text-sm font-medium leading-normal">
              ID: {employeeId || "N/A"}
            </p>
            <p className="text-display-body text-sm font-medium leading-normal">
              {designation || "Designation: N/A"}
            </p>
            <p className="text-display-body text-sm font-medium leading-normal">
              Department of
              <span className="text-tint-warning ml-1.5">
                {department || "N/A"}
              </span>
            </p>

            {/* Email in a single line with ellipsis */}
            <p className="text-display-body text-sm font-medium leading-normal flex items-center">
              Email:{" "}
              <Tooltip title={email || "N/A"}>
                <a
                  className="text-accent ml-1.5 hover:underline truncate overflow-hidden inline-block align-middle max-w-[150px] whitespace-nowrap"
                  href={`mailto:${email}`}
                >
                  {email || "N/A"}
                </a>
              </Tooltip>
            </p>

            <p className="text-display-body text-sm font-medium leading-normal">
              Joining Date:
              <span className="text-tint-warning ml-1.5">
                {joinedDate || "N/A"}
              </span>
            </p>
          </div>
        </Space>
      </div>
    </div>
  );
}
